//@flow
import { combineReducers } from 'redux'

import client from './client/reducer'
import learner from './learner/reducer'
import questions from './questions/reducer'
import quiz from './quiz/reducer'
import courses from './courses/reducer'

const rootReducer = combineReducers({
  client,
  learner,
  questions,
  quiz,
  courses
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/state/reducer.js